import { Button, Card, FormControl, Grid, InputLabel, MenuItem, Select, makeStyles, TextField } from "@material-ui/core"
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { ValidatorForm } from "react-material-ui-form-validator";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import ValidatedDatePicker from "../../compartidos/ValidatedDatePicker";
import moment from "moment";
import { useForm } from "../../../hooks/useForm";
import { useDispatch, useSelector } from "react-redux";
import { ESTADO_VALORIZACIONES_DISCAPACIDAD } from "../../../utils/constants";
import { setActivosPorFecha } from "../../../actions/discapacidad/nomencladorDiscaActions";

const useStyles = makeStyles({
    card: {
        padding: "1rem"
    }
});

export const BuscadorNomencladorDiscapacidad = ({ handleSearch, setFiltroExcel }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { activosPorFecha } = useSelector(state => state.nomencladorDiscapacidad);

    const initialValues = {
        discapacidadFiltro: null,
        fechaDesde: null,
        fechaHasta: null
    };

    const [
        formValues,
        ,
        ,
        setearValor
    ] = useForm(initialValues);

    const { discapacidadFiltro, fechaDesde, fechaHasta } = formValues;

    const obtenerEstadoValorizacion = (numero) => {
        for (const clave in ESTADO_VALORIZACIONES_DISCAPACIDAD) {
            if (ESTADO_VALORIZACIONES_DISCAPACIDAD[clave] === numero) {
                return clave;
            }
        }
    }

    return (
        <Card className={classes.card}>
            <Grid container justify='center' alignItems='center' >
                <Grid item xs={8}>
                    <ValidatorForm onSubmit={handleSearch}>
                        <Grid item xs={10} style={{ marginTop: "-1.5rem" }}>
                            <Grid container justify='flex-start' spacing={2}>
                                <Grid item xs={6}>
                                    <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                        <ValidatedDatePicker
                                            fullWidth
                                            margin="normal"
                                            label="Fecha Desde"
                                            format="dd/MM/yyyy"
                                            okLabel="Aceptar"
                                            clearLabel="Limpiar"
                                            cancelLabel="Cancelar"
                                            maxDate={fechaHasta}
                                            maxDateMessage={`La fecha no puede ser posterior a la fecha de fin`}
                                            value={moment(fechaDesde).isValid()
                                                ? moment(fechaDesde)
                                                : null}
                                            onChange={(date) => setearValor('fechaDesde', moment(date).format())}
                                            KeyboardButtonProps={{
                                                "aria-label": "change date",
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item xs={6}>
                                    <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                        <ValidatedDatePicker
                                            fullWidth
                                            margin="normal"
                                            label="Fecha Hasta"
                                            format="dd/MM/yyyy"
                                            okLabel="Aceptar"
                                            clearLabel="Limpiar"
                                            cancelLabel="Cancelar"
                                            minDate={fechaDesde}
                                            minDateMessage={`La fecha no puede ser anterior a la fecha de inicio`}
                                            value={moment(fechaHasta).isValid()
                                                ? moment(fechaHasta)
                                                : null}
                                            onChange={(date) => setearValor('fechaHasta', moment(date).format())}
                                            KeyboardButtonProps={{
                                                "aria-label": "change date",
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={10} style={{ marginTop: "-1.5rem" }}>
                            <TextField
                                margin="normal"
                                fullWidth
                                name="discapacidadFiltro"
                                label="Código"
                                value={discapacidadFiltro}
                                autoComplete="off"
                                onChange={(e) => setearValor('discapacidadFiltro', e.target.value)}
                            />
                        </Grid>
                    </ValidatorForm>

                    <Grid container justify='space-between' alignItems={'center'} spacing={3} style={{ marginTop: "0.1rem" }}>
                        <Grid item xs={10}>
                            <FormControl fullWidth>
                                <InputLabel id="select-dataPorFecha-label">Estado por Fecha</InputLabel>
                                <Select
                                    style={{ marginTop: 13 }}
                                    value={activosPorFecha}
                                    labelId="select-dataPorFecha-label"
                                    onChange={(e) => { dispatch(setActivosPorFecha(e.target.value)) }}
                                >
                                    <MenuItem value={ESTADO_VALORIZACIONES_DISCAPACIDAD.VIGENTES}>Vigentes</MenuItem>
                                    <MenuItem value={ESTADO_VALORIZACIONES_DISCAPACIDAD.NO_VIGENTES}>No vigentes</MenuItem>
                                    <MenuItem value={ESTADO_VALORIZACIONES_DISCAPACIDAD.TODOS}>Todos</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={2} style={{ marginTop: "-7rem" }}>
                            <Button
                                variant="contained"
                                color="primary"
                                type="submit"
                                onClick={() => {
                                    handleSearch(activosPorFecha, discapacidadFiltro ? discapacidadFiltro : null, fechaDesde, fechaHasta)
                                    setFiltroExcel({
                                        activosPorFecha: obtenerEstadoValorizacion(activosPorFecha),
                                        discapacidadFiltro: discapacidadFiltro ? discapacidadFiltro : null,
                                        fechaDesde: fechaDesde,
                                        fechaHasta: fechaHasta
                                    })
                                }}
                            >
                                Filtrar
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Card>
    )
}
